import { instagram, facebook, linkedin, tiktok, medium, nadeeshaan, dulaj, thilina, kosala, harshana, pathum, thilanka, graduate, engineer, leader, instructor, cricketer, singer, lecturer, bloodbank, git, birthday, email, 
  bEmail, location, siyapatha, badminton, mkpl, ol, chem, acedemic, ontobot, rpc, pp, whether, tms, chat, pathumProduct, dimuthu, 
  wso2b, javab, pythonb, guru, thevin, ifs, prof, uoc,indimemo, govindu, anuj, nipunika, chatura } from "../assets";
import { c, html, java, js, php, python, react, sql, web, webFunda, ifsBld, ifsWeb, ifsLifeCycle, ifsWebDeveloper, ifsDataManagement, ifsDevelopment,
  ifsDataManagementMethodology, ifsDataMigrationTool, ifsExcelMigration } from "./certificates";

export const feedback = [
    {
      id: "feedback-1",
      content:
        "Madushanka was my intern at WSO2 and during his tenure, he showed that he is a very technically talented engineer. Madushanka is so passionate about learning new things and also he is a quick learner who can take responsibility to see the successful completion of a task. He is a very good team player and any team can depend on him for any complex task with greater confidence.",
      name: "Nadeeshaan Gunasingha",
      title: "Former Technical Lead at WSO2( The Mentor of my internship project ) & Author",
      img: nadeeshaan,
    },
    {
      id: "feedback-2",
      content:
        "Working with Madusanka was a breath of fresh air due to his strong work ethic and reliability. He consistently delivers high-quality work on time and with great attention to detail. It's rare to come across someone as motivated and enthusiastic, and who consistently goes above and beyond to ensure that the team meets its targets.",
      name: "Chatura Wijenayake",
      title: "Senior Software Architect at IFS",
      img: chatura,
    },
    {
      id: "feedback-3",
      content:
        "Quick learner. Shows a good attitude. A doer.",
      name: "Dulaj Dilshan",
      title: "Lead Software Engineer at WSO2",
      img: dulaj,
    },
    {
      id: "feedback-4",
      content:
        "First and foremost, I'd want to congratulate you on your success and advancement in your career. I had the pleasure of working with Nipunajith at the Sasip institute as a SAP team leader for more than a year. He was organized, efficient and willing to do whatever was needed to get a particular task finished. He was a very honest and dedicated team member with a great attitude and a strong work ethic. He was also a very dependable team player. “Life is filled with unexpected adventures”. As you continue to move on in life and face new events, adventures, and challenges, I wish you the best of luck in all of your future endeavours!",
      name: "Thilanka Rajapaksha",
      title: "Former Group Leader(SAP Team Leaders) & MBBS (UG)",
      img: thilanka,
    },
    {
      id: "feedback-5",
      content:
        "First, I had wanted to congratulations you on your success in your career. I had the pleasure of working with Nipunajith at the Susipwan institute as a instructor for more than year. He is very charm,patient,innocent,cleverful and very efficient .Not only education he is vey clever at extra curriculum activities such as cricket.He always works neatly .I wish best regards to your future successful",
      name: "Pathum Chirantha",
      title: "Civil Engineer/ Bsc Engineering (Hons) at University of Moratuwa",
      img: pathum,
    },
    {
      id: "feedback-6",
      content:
        "First I like to congratulate your career. You are a good friend that I met in the university. I know you from the school time but we became close friends when we were at the university. Matuared knowledge and the helpfullness is the most special thing I seen from you. I wish you best of luck for your future career.",
      name: "Harshana Walpita",
      title: "Senior Software Engineer at IFS",
      img: harshana,
    },
    {
      id: "feedback-7",
      content:
        "Firstly I would like to congratulate for advancement of your carrere. I had work with him more than 1 year at 'Susipone' instutute as a instructor. He was very clever, organized, keen to learn any thing, very neat and has lot of encouragement to do something. As a person anyone can work with him without any hesitate. He can handle a team in a betterway because he has such a qualities of team leader. Not only that but also he was clever in programming and IT fields. He is one of a such a humble, straightforward , efficient, honest and dedicated team member in my team. At last I just want to wish you best of luck for your new start in journey. In your life may you get what you want and you never have to strive. Wishing you all the best !!",
      name: "Kosala Waruni",
      title: "BSC Engineering (Hons) at University of Ruhuna",
      img: kosala,
    },
    {
      id: "feedback-8",
      content:
        "First of all I like to congratulate you for your new milestone. It was really great time that I worked with you in our school days. He is smart worker who can understand things very fast. I can say he is very good for problem solving as he solve the mathematic questions in school days very fast and efficient way. He is a hard and also smart worker who can do the things in his own way. I wish you very best of luck for your new journey and like to see your great success.",
      name: "Thilina Dilshan",
      title: "Senior Software Engineer at Different",
      img: thilina,
    },
    {
      id: "feedback-9",
      content: "Madusanka Nipuanajith is an undergraduate at UCSC reading for a degree in Computer Science. He is a motivated individual with excellent analytical skills and a strong ability to work effectively in a team. Madusanka is always eager to learn and absorbs new information quickly. He is a driven and focused individual who is committed to achieving his goals.",
      title: "Software Engineer at Creative Software",
      name: "Dimuthu Dhanushka",
      img: dimuthu,
    },
    {
      id: "feedback-10",
      content: "Before I begin, I would like to congratulate you for all the great achievements so far in your life journey. Madushanka is a genuine and humble classmate I met during the A/Ls. He is also a hardworking, energetic and self-motivated person who loves to accept new challenges and is always ready to absorb new knowledge. Apart from studies he was engaged in other extra-curricular activities as well. Finally, wishing you all the best along each step of your journey. Go after your dreams! Make us proud.",
      title: "BSC Engineering (Hons) at University of Moratuwa",
      name: "Thevin Jayasekara",
      img: thevin
    },
    {
      id: "feedback-11",
      content: "I've had the pleasure of working with Madusanka and he is truly one of the best colleagues I've encountered. He consistently deliver high-quality work on time, and his potential for growth is incredibly exciting.  But what truly sets him apart is his personality. Madusanka is both humble and friendly, fostering a positive and collaborative work environment. His passion for learning new things is inspiring, and his ability to understand and respect others' perspectives makes him a fantastic team player. He is well-organized, dedicated, and a true asset to any team.",
      title: "Senior Product Specialist at IFS (CIMA/MBA)",
      name: "Govindu Sithila",
      img: govindu
    },
    {
      id: "feedback-12",
      content: "Madusanka is a young, energetic software engineer who has a visionary sense of the endeavours he is expecting to achieve. He is really passionate and enthusiastic about completing any assigned task effectively and holds responsibility and accountability with integrity. He possesses strong potential and capacity to handle situations of various complexity levels in an efficient manner.",
      title: "Senior Product Specialist at IFS/ Financials Consultant",
      name: "Anuj Bandara",
      img: anuj
    },
    {
      id: "feedback-13",
      content: "Working with Madusanka has been a real privilege for me. He is truly one of the best colleagues I've ever worked with. He always delivers great work on time and is eager to grow and learn more. What makes Madusanka stand out even more is his personality. He is humble and easy to talk to, which makes our team work together really well. He always wants to learn new things, which encourages all of us to improve. Finally I wish all the very best for his journey",
      title: "Senior Product Specialist at IFS/ Founder at Rafaella",
      name: "Nipunika Sooriarachchi",
      img: nipunika
    }
   
  ];

  export const socialMedia = [
    {
      id: "social-media-1",
      icon: instagram,
      link: "https://www.instagram.com/madusankanipunajith/",
    },
    {
      id: "social-media-2",
      icon: facebook,
      link: "https://m.facebook.com/madusanka.nipunajith",
    },
    {
      id: "social-media-3",
      icon: git,
      link: "https://github.com/MadusankaNipunajith",
    },
    {
      id: "social-media-4",
      icon: linkedin,
      link: "https://www.linkedin.com/in/madusankanipunajith/",
    },
    {
      id: "social-media-5",
      icon: tiktok,
      link: "https://www.tiktok.com/@madusankanipunajith",
    },
    {
      id: "social-media-6",
      icon: medium,
      link: "https://medium.com/@madushankanipunajith",
    },
  ];

  export const roles = [
    {
      id: "role-1",
      icon:engineer,
      title: "SSE at IFS (R&D)"
    },
    {
      id: "role-2",
      icon:lecturer,
      title: "Visiting Lecturer"
    },
    {
      id: "role-3",
      icon:graduate,
      title: "Valedictorian at UOC/UCSC"
    },
    {
      id: "role-4",
      icon:engineer,
      title: "Former SE(Intern) at WSO2"
    },
    {
      id: "role-5",
      icon:leader,
      title: "Former SAP Team Leader"
    },
    {
      id: "role-6",
      icon:instructor,
      title: "Former Math Instructor"
    },
    {
      id: "role-7",
      icon:cricketer,
      title: "Softball Cricket Player"
    },
    {
      id: "role-8",
      icon:singer,
      title: "Vocalist"
    },
  ];

  export const projects = [
    {
      topic:'YUTHUKAMA (OBMS)',
      img: bloodbank,
      description: 'Worked on the second year group project to develop and deploy a Centralized Blood Bank Management System for Hospitals and Blood Banks in Sri Lanka. Worked closely with the project supervisors by adjusting functionalities and the user experience of the application. Was able to get familiar with project management tools(Trello) and Git Version Controlling.',
      tech:['Full Stack Development',
        'PHP',
        'MySQL',
        'Javascript',
        'HTML']
    },
    {
      topic:'STITCHES & CURVES (TMS)',
      img: tms,
      description: 'We proposed a web-based application so that customers can have access to an online tailor shop and have their needs satisfied even without stepping out of their comfort zone; home and the tailors can promote their textile products online. This project aims to automate the manually maintained tailoring sector. We are trying to help people to make their lives easier by providing online tailor-made clothes shopping.',
      tech:['MERN Stack Development',
        'Express JS',
        'Docker',
        'GCP']
    },
    {
      topic:'Traditional Weather Detector',
      img: whether,
      description: 'I was able to implement a simple traditional weather app using Open weather API. By using this application users can see the current weather data for given location in the world.',
      tech:['Node JS',
        'OpenWhetherMap']
    },
    {
      topic:'Games for Kids (Proffesional Practice)',
      img: pp,
      description: 'We have implemented a web application called Games for Kids under the Professional practice course for giving solutions on ethical issues that are faced by kids while they are playing games. The main purpose of the project is to help parents of kids. We tried to complete the project by using code of conducts as well.',
      tech:['Game Categories',
        'Language Translator',
        'ESRB Ratings',
        'Parent Controlling Tools',
        'PEGI Ratings']
    },
    {
      topic:'Real time chat application (Learning)',
      img: chat,
      description: 'I have implemented a chat application called “Jithson chat”. The main purpose of the project is to learn how real-time applications behave and how to implement them. by using this project I was able to understand the socket.io in node. I deployed this project to Heroku as well. This application has these features',
      tech:['User can create a room',
        'They can share their current location',
        'Bad word filtering',
        'Acknowledgment (new user login and left out)',
        'Online users displaying within the chat room']
    },
    {
      topic:'JSON RPC Library and Client-Server Framework from Ballerina',
      img: rpc,
      description: 'I have implemented a research project called “JSON RPC Library & Client-Server framework from Ballerina” as my internship project at WSO2. Mr. Nadeeshaan Gunasingha who is a former tech lead at WSO2 was the mentor of that particular project. I was able to get a lot of experiences (technical and non-technical) by doing this project. After completing the project we pushed our project into the Ballerina Central. Activities of my internship project',
      tech:['Did research on the project and created a system specification.',
        'Did the implementation of the project and testing.',
        'Added use cases for the implemented project.',
        'Created descriptive documentation for the project.',
        'Did a code review and pushed to the Ballerina central.']
    },
    {
      topic:'Ontobot (FYP)',
      img: ontobot,
      description: 'This is my final year research project. It is a group project and we are developing a tool called Ontobot which can generate ontologies(knowledge representation technique) according to the general ontology design patterns(ODPs) to enhance the quality of the ontology in terms of correctness and completeness. We have selected 8 ODPs for demonstrating the project and adding other odps is further extension. The main research component of this project is getting user inputs with respect to the ODPs and mapping inputs with rules of ODPs. Then, We will have to generate an OWL file at the end. Moreover, followings are the technologies and tools we have used in the project.', 
        tech:['React',
        'TailwindCSS',
        'Python',
        'Java',
        'Trello']
    },
    {
      topic:'Website for Pathum Products',
      img: pathumProduct,
      description: 'This is my first real client product. I have implemented a single page website for Pathum Products(cricket bat making and modifying company) according to their requirements. They can easily show off their products,features and etc through the website to the customers. Following technologies have been used for developing the website.',
      tech:['React',
        'TailwindCSS',
        'Vite']
    },
    
    
  ];

  export const awards = [
    {
      topic:'Man of the Match (Siyapatha CT 2018)',
      img: siyapatha,
      description: 'I was able to obtain the trophy for the man of the match due to the best performance throughout the tournament. It was unforgettable incident in my life. Furthermore I would like to mention here my team members.',
      member:['Thilanka Rajapaksha',
        'Pramod Dhananjaya',
        'Pasindu Ayesh',
        'Thihara',
        'Akila Lakshan',
        'Sandun']
    },
    {
      topic:'Team member of the Champions team(FRESHERS BADMINTON 2019)',
      img: badminton,
      description: 'I was able to be a member of the badminton squad of UCSC in Freshers Badminton tournament 2019. As a team we were able to be the champions there. it was an another unforgettable event in my life. furthermore I would like to mention here my team members.',
      member:['Sahan Dissanayaka',
        'Bhagya Gunathilaka',
        'Hashen Rashminda',
        'Manthila Bandara']
    },
    {
      topic:'Best Results Award (O/L)',
      img: ol,
      description: 'I was able to be achieve the best result award of Sipsara institute in Gampaha in 2013. This trophy was given for 6 students only and I was lucky to be among them. So it was a remarkable incident in my life.',
      member:[]
    },
    {
      topic:'Chemistry Award (A/L)',
      img: chem,
      description: 'I was able to obtain the second place of final examination. This award was given by Charitha Dissanayaka who is famous chemistry teacher in Srilanka. Moreover, I was able to achieve the fourth place among all the classes held by charitha sir. So It was unforgettable incident in my life.',
      member:[]
    },
    {
      topic:"Director's List Awards (University)",
      img: acedemic,
      description:'I was able to select to the director’s list (called as dean’s list also) in first semester, second semester, third semester and fourth semester. Actually, I think it is a dream of an undergraduate and I was lucky enough to achieve that goal. Therefore, it is also an unforgettable achievement in my life.' ,
      member:[]
    },
    {
      topic:"IFS Award for the highest GPA in SE",
      img: ifs,
      description:'I was able to achieve the IFS Award in the general convocation 2022. Actually, I think it is a dream of an undergraduate and I was lucky enough to achieve that goal. Therefore, it is also an unforgettable achievement in my life. Moreover special thank goes to' ,
      member:['My Parents', 'Sister', 'Adithya Deshan', 'Kosala Marian', 'Harshana Walpita']
    },
    {
      topic:"Prof Wimala Jayarathna Memorial Award",
      img: prof,
      description:'I was able to achieve the Prof Wimala Jayarathna Memorial Award in the general convocation 2022. Actually, I think it is a dream of an undergraduate and I was lucky enough to achieve that goal. Therefore, it is also an unforgettable achievement in my life. Moreover special thank goes to' ,
      member:['My Parents', 'Sister', 'Adithya Deshan', 'Kosala Marian', 'Harshana Walpita']
    },
    {
      topic:"UOC Award for the best performance in SE",
      img: uoc,
      description:'I was able to achieve the UOC Award in the general convocation 2022. Actually, I think it is a dream of an undergraduate and I was lucky enough to achieve that goal. Therefore, it is also an unforgettable achievement in my life. Moreover special thank goes to' ,
      member:['My Parents', 'Sister', 'Adithya Deshan', 'Kosala Marian', 'Harshana Walpita']
    },
    {
      topic:"Best Batsman (Indika Memorial Tournament 2024)",
      img: indimemo,
      description:"I was able to obtain the trophy for the best batsman due to the best performance throughout the tournament. It was an amaizing memory in my life and as a team we were able to be the champions in the tournament. Here I would like to thank followings.",
      member:['Organizer of the tournament', 'Nuwan Sameera (C)', 'The Team']
    },
    {
      topic:"Player of the match (MKPL Tournament 2025)",
      img: mkpl,
      description:"I was able to obtain the trophy for the player of the match due to the best performance throughout the tournament. It was an unforgettable memory in my life and as a team we were able to be the runners-up in the tournament. Here I would like to thank followings.",
      member:['Organizer of the tournament', 'K Pramuth Kurera (C)', 'The Team']
    }

  ];

  export const certificates = [
      {img:js},
      {img:html},
      {img: sql},
      {img: java},
      {img: python},
      {img: web},
      {img: webFunda},
      {img: react},
      {img: php},
      {img: c},
      {img: ifsBld},
      {img: ifsWeb},
  ]

  export const badges = [
    {img: wso2b},
    {img: javab},
    {img: pythonb},
    {img: guru},
    {img: ifsLifeCycle},
    {img: ifsWebDeveloper},
    {img: ifsDevelopment},
    {img: ifsDataManagement},
    {img: ifsDataManagementMethodology},
    {img: ifsDataMigrationTool},
    {img: ifsExcelMigration},
  ]

  export const emails = [
    {
      id: 0,
      icon:birthday,
      title:'1997 September 28'
    },
    {
      id: 1,
      icon:email,
      title:'madushankanipunajith@gmail.com'
    },
    {
      id: 2,
      icon:bEmail,
      title:'jithsonwebsite@gmail.com'
    },
    {
      id: 3,
      icon:location,
      title:'168/B, Oruthota, Gampaha'
    }
  ];